import { useEffect } from 'react'
import './style.scss'
const PATH = process.env.PUBLIC_URL

function NotFound() {

	useEffect(() => {
		document.title ='Страница не найдена';
	}, [])

    return <div className="not-found">
        <div className="not-found__image">
            <img src={`${PATH}/not-found.png`} alt="" />
        </div>
        <div className="not-found__title">Такой страницы не существует</div>
        <div className="not-found__descr">Возможно, был введен неверный адрес страницы <br></br> или страница была удалена с сервера</div>
        <a href="/" className="btn btn--primary">Перейти на главную</a>
    </div>
}

export default NotFound
